module.exports = __webpack_public_path__ + "img/image26@2x.7f2611d7.png";